import React from "react";
import styles from './MarketingScreenNew.module.css'
import whatappIconImage from '../../Assets/Images/whatapp-icon-benefit-table.svg'
import greenCheckImage from '../../Assets/Images/green-check-benefit-table.svg'

interface MarketingWhyReadProWhatsappProps { }

const MarketingWhyReadProWhatsapp: React.FC<MarketingWhyReadProWhatsappProps> = () => {
    return (
        <div className={styles.FreeTrialMarketing}>
            <div className={styles.FreeTrialMarketingWrapper}>
                <div className={styles.FreeTrialMarketingTitle}><span className={styles.WhatappIcon}><img src={whatappIconImage} /></span>Why <span className={styles.TextGreen}>ReadPro</span> Whatsapp marketing wins</div>
                <div className={styles.FreeTrialMarketingSubtxt}>over personal message or other competitors</div>
                <div className={styles.BenefitWrapper}>
                    <div className={styles.BenefitTable}>
                        <div className={styles.BenefitHeader}>
                            <div className={styles.BenefitRow}>
                                <div className={styles.BenefitCol}>Benefits</div>
                                <div className={`${styles.BenefitCol} ${styles["wrpro"]}`}>
                                    <div className={`${styles.text} ${styles.textSemibold}`}>With ReadPro</div>
                                    <div className={styles.textSmall}>WhatsApp Marketing</div>
                                </div>
                                <div className={styles.BenefitCol}>
                                    <div className={styles.text}>Other Competitors</div>
                                    <div className={styles.textSmall}>WhatsApp Marketing</div>
                                </div>
                                <div className={styles.BenefitCol}>
                                    <div className={styles.text}>Personal</div>
                                    <div className={styles.textSmall}>WhatsApp message</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.BenefitBody}>
                            <div className={styles.BenefitRow}>
                                <div className={styles.BenefitCol}><span className={styles.textSemibold}>Real Estate focused message templates</span></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                                <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                            </div>
                            <div className={styles.BenefitRow}>
                                <div className={styles.BenefitCol}><span className={styles.textSemibold}>Broadcast message to multiple clients</span></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                            </div>
                            <div className={styles.BenefitRow}>
                                <div className={styles.BenefitCol}><span className={styles.textSemibold}>Automatic Messages</span>
                                </div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                            </div>
                            <div className={styles.BenefitRow}>
                                <div className={styles.BenefitCol}><span className={styles.textSemibold}>Verified business account with blue tick</span>
                                <div className={styles.Condition}>*Subject to Meta Approval</div>
                                </div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                            </div>
                            <div className={styles.BenefitRow}>
                                <div className={styles.BenefitCol}><span className={styles.textSemibold}>Zero Platform fee</span></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                            </div>
                            <div className={styles.BenefitRow}>
                                <div className={styles.BenefitCol}><span className={styles.textSemibold}>100% assured data privacy</span></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                                <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                            </div>
                            <div className={styles.BenefitRow}>
                                <div className={styles.BenefitCol}><span className={styles.textSemibold}>CRM Integration</span></div>
                                <div className={styles.BenefitCol}><img className={styles.checkSign} src={greenCheckImage} /></div>
                                <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                                <div className={styles.BenefitCol}><span className={styles.crossSign}></span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarketingWhyReadProWhatsapp